import { render, staticRenderFns } from "./SendNote.vue?vue&type=template&id=3a8ace5a"
import script from "./SendNote.vue?vue&type=script&lang=js"
export * from "./SendNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports